// eslint-disable-next-line import/no-cycle
import { Authentication } from '@icabbi/vue-authentication';
import store from '../store';

export default async function routeGuard(to, from, next) {
  await Authentication(store).handleAuthentication(next);
}
